import Service from './axiosClient';

export async function getListUser(params) {
  const service = new Service();
  service.createAxios();
  const resp = await service.get(
    `listUser?pageToken=${params.pageToken}&limit=${params.limit}&phoneNumber=${params.phoneNumber}`,
  );
  return resp.data;
}

export async function getUserDetail(params) {
  const service = new Service();
  service.createAxios();
  const resp = await service.get(`userDetail?userId=${params.userId}`);
  return resp.data;
}

export async function getRecordsGroup(params) {
  const service = new Service();
  service.createAxios();
  const resp = await service.get(
    `getRecordsGroup?userId=${params.userId}&fromDate=${params.fromDate}&toDate=${params.toDate}&page=${params.page}&limit=${params.limit}`,
  );
  return resp.data;
}

export async function getRecords(params) {
  const service = new Service();
  service.createAxios();
  const resp = await service.get(
    `getRecords?groupId=${params.groupId}&fromDate=${params.fromDate}&toDate=${params.toDate}&page=${params.page}&limit=${params.limit}`,
  );
  return resp.data;
}

export async function getPin(params) {
  const service = new Service();
  service.createAxios();
  const resp = await service.post('storeUploadCode', { userId: params.userId });
  return resp.data;
}

export async function exportRecordsGroup(params) {
  const service = new Service();
  service.createAxios();
  const resp = await service.post(`exportRecordsGroup`, {
    userId: params.userId,
    fromDate: params.fromDate,
    toDate: params.toDate,
  });
  return resp.data;
}

export async function getUserCount() {
  const service = new Service();
  service.createAxios();
  const resp = await service.get(`getUserCount`);
  return resp.data;
}
